import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../../api/services/auth.service';
import { MarketService } from '../../../api/services/market.service';
import { UserService } from '../../../api/services/user.service';
import { ReportService } from '../../../api/services/report.services';
import { ProjectService } from '../../../api/services/project.services';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Market } from '../../../api/models/market-model';
import { Organization } from '../../../api/models/organization';
import { RoleRequest, RoleResponse } from '../../../api/models/role-assignment-map';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { PaginatedRequest } from '../../../api/models/paginated-request';
import { worksheetStatusReportRequest } from '../../../api/models/project-summary';
import { WorksheetStatusHistory, WorksheetStatus } from '../../../api/models/worksheet-status';
import { Project} from '../../../api/models/project-model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AnalyticsService } from '../../../api/services/analytics.service';

@Component({
    selector: 'app-worksheetstatus-report',
    templateUrl: './worksheetstatus-report.component.html',
    styleUrls: ['./worksheetstatus-report.component.scss']
})
export class WorksheetStatusReportComponent implements OnInit {

    roleRequest: RoleRequest;
    isTesscoAdmin: boolean;
    isClientAdmin: boolean;
    organizations: Organization[] = [];
    selectedOrgId = '';
    selectedOrg: Organization[] = [];
    accountNumber: string;
    markets: Market[] = [];
    selectedMarket: Market[] = [];
    selectedAccountNumber: string;
    selectedLocationCode: string;
    loading = true;
    page = 1;
    pageSize = 20;
    totalRecords = 0;
    startRecord: number;
    endRecord: number;
    noWorksheetMessage = ['There are no orders to display for this market.'];
    paginatedRequest: PaginatedRequest;
    projectPaginatedRequest: PaginatedRequest;
    wsStatusReport: WorksheetStatusHistory = new WorksheetStatusHistory();
    showWsSearchOption: boolean = false;
    showNoWSMessage = false;
    errorMessage: string[] = [];
    reportFilterSearchValue: string = '';
    reportFilterKeyValue: string = 'worksheetName';
    tempOrders: WorksheetStatus[];

    orgDropdownSettings: IDropdownSettings;
    marketDropdownSettings: IDropdownSettings;
    projectDropdownSettings: IDropdownSettings;

    marketDropdownDisabled: boolean = true;

    blob: any;
    excelLoading: boolean = false;
    excelBtnDisabled: boolean = true;

    projectList: Project[] = [];
    fetchedProjectIds = [];
    projects: Project[] = [];
    selectedProject: Project[] = [];
    selectedProjectId: string;
    selectedProjectName: string;

    sortDirection: string;
    wsNameSortDirection = '';
    oraclePrNumberSortDirection = '';
    projectNameSortDirection = '';
    initBySortDirection = '';
    initDateSortDirection = '';
    SubApprDateDeliveryDate = '';
    subApprBySortDirection = '';
    DesApproverSortDirection = '';
    apprDateSortDirection = '';
    approvedBySortDirection = '';
    statusSortDirection = '';
    @ViewChild('accordion') accordion: NgbAccordion;



    constructor(
        private authService: AuthService,
        private userService: UserService,
        private marketService: MarketService,
        private toastr: ToastrService,
        private reportService: ReportService,
        private projectService: ProjectService,
        private analyticsService: AnalyticsService
    ) { }

    ngOnInit() {
        this.loading = true;
        this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
        this.roleRequest.setRoleAndContextMap('ADMIN_CLIENT', null);
        forkJoin(this.authService.getUserRoles(this.roleRequest), this.userService.getOrganizationsForUser())
            .subscribe((data: [RoleResponse, Organization[]]) => {
                this.isTesscoAdmin = data[0].getRoleMap('ADMIN_TESSCO');
                this.isClientAdmin = data[0].getRoleMap('ADMIN_CLIENT');
                this.organizations = data[1]
                    .sort((a, b) => (a.Name.toLowerCase() > b.Name.toLowerCase() ? 1 : -1));

                if (this.organizations.length == 1) {
                    this.changeOrg(this.organizations[0]);
                } else {
                    this.loading = false;
                }
            }, error => {
                this.noWorksheetMessage = ['Failed to fetch Worksheet Status Report data'];
                this.loading = false;
                this.showNoWSMessage = true;
            });
        this.setOrgDropdownSettings();
        this.setMarketDropdownSettings();
        this.setProjectDropdownSettings();
    }

    getMarkets(currentOrgId: string) {
        this.markets = [];
        this.marketService.getMarkets(currentOrgId).subscribe(markets => {
            this.markets = markets;
            if (this.markets.length > 0) {
                this.marketDropdownDisabled = false;
                if (this.markets.length == 1) {
                    this.changeMarket(this.markets[0]);
                } else {
                    this.markets = this.markets
                        .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
                    this.loading = false;
                }
            } else {
                this.noWorksheetMessage = ['There are no markets for this organization.'];
                this.loading = false;
                this.totalRecords = 0;
                this.markets = [];
                this.showNoWSMessage = true;
                this.showWsSearchOption = false;
                this.excelBtnDisabled = true;
            }
        }, error => {
            this.noWorksheetMessage = ['Failed to fetch Worksheet Status Report data'];
            this.loading = false;
            this.totalRecords = 0;
            this.markets = [];
            this.showNoWSMessage = true;
            this.showWsSearchOption = false;
            this.excelBtnDisabled = true;
        });
    }

    changeOrg(organization: Organization) {
        this.selectedOrg = [];
        this.markets = [];
        this.projects = [];
        this.selectedMarket = [];
        this.selectedProject = [];
        this.totalRecords = 0;
        this.wsStatusReport = new WorksheetStatusHistory();
        if (organization.Name.length > 27) {
            organization.Name = organization.Name.slice(0,27) + "...";
        }
        this.selectedOrg.push(organization);
        this.selectedOrgId = organization['Organization ID'];
        this.loading = true;
        this.errorMessage = [];
        this.showNoWSMessage = false;
        this.showWsSearchOption = false;
        this.excelBtnDisabled = true;
        this.getMarkets(this.selectedOrgId);
    }

    changeMarket(market: Market) {
        this.selectedMarket = [];
        this.selectedProject = [];
        this.projects = [];
        this.wsStatusReport = new WorksheetStatusHistory();
        this.totalRecords = 0;
        if (market.name.length > 27) {
            market.name = market.name.slice(0,27) + "...";
        }
        this.selectedMarket.push(market);
        this.selectedAccountNumber = this.markets.reduce((acc, curr) => {acc[curr.id] = curr; return curr}).accountNumber;
        this.loading = true;
        this.showNoWSMessage = false;
        this.showWsSearchOption = false;
        this.excelBtnDisabled = true;
        this.getProjects();
    }

    changeProject(project: Project) {
        this.selectedProject = [];
        this.totalRecords = 0;
        if (project.name.length > 27) {
            project.name = project.name.slice(0,27) + "...";
        }
        this.selectedProject.push(project);
        if (this.isTesscoAdmin || this.isClientAdmin) {
            this.selectedProjectId = this.selectedProject[0].id;
        } else if (this.selectedProject[0].id === "ALL") {
            this.selectedProjectId = this.fetchedProjectIds.join(',');
        } else {
            this.selectedProjectId = this.selectedProject[0].id;
        }
        this.selectedProjectName = this.selectedProject[0].name;
        this.loadPage(1, this.selectedAccountNumber, this.selectedMarket[0].id, this.selectedMarket[0].name, this.selectedProjectId, this.selectedProjectName);
    }

    getProjects() {
        if (this.isTesscoAdmin || this.isClientAdmin) {
            this.projectService.getProjectsForMarket(this.selectedMarket[0].id).subscribe(projs => {
                this.projectList = projs;
                if (this.projectList && this.projectList.length > 0) {
                    this.projectList = this.projectList
                        .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
                    let allProject = new Project();
                    allProject.id = "ALL";
                    allProject.name = "ALL";
                    // Adding ALL option as first element in the Array
                    this.projectList.unshift(allProject);
                    this.projects = this.projectList;
                    this.changeProject(allProject);
                } else {
                    this.loading = false;
                    this.totalRecords = 0;
                    this.projects = [];
                    this.wsStatusReport.records = [];
                    this.noWorksheetMessage = ['There are no projects for this market']
                    this.showNoWSMessage = true;
                    this.excelBtnDisabled = true;
                }
            }, error => {
                this.noWorksheetMessage = ['Failed to fetch Worksheet Status Report data'];
                this.loading = false;
                this.totalRecords = 0;
                this.showNoWSMessage = true;
                this.showWsSearchOption = false;
                this.excelBtnDisabled = true;
            });
        } else {
            this.projectService.getProjects(this.selectedMarket[0].id, new PaginatedRequest(1, 2000)).subscribe(result => {
                this.projectList = result;
                if (this.projectList && this.projectList.length > 0) {
                    this.projectList = this.projectList
                        .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
                    this.fetchedProjectIds = this.projectList.map(proj => proj.id);
                    let allProject = new Project();
                    allProject.id = "ALL";
                    allProject.name = "ALL";
                    // Adding ALL option as first element in the Array
                    this.projectList.unshift(allProject);
                    this.projects = this.projectList;
                    this.changeProject(allProject);
                } else {
                    this.loading = false;
                    this.totalRecords = 0;
                    this.projects = [];
                    this.wsStatusReport.records = [];
                    this.noWorksheetMessage = ['There are no projects for this market']
                    this.showNoWSMessage = true;
                    this.excelBtnDisabled = true;
                }
              }, error => {
                this.noWorksheetMessage = ['Failed to fetch Worksheet Status Report data'];
                this.loading = false;
                this.totalRecords = 0;
                this.showNoWSMessage = true;
                this.showWsSearchOption = false;
                this.excelBtnDisabled = true;
            });
        }
    }

    loadPage(page, customerNumber: string, marketId: string, marketName: string, projectId: string, projectName: string, reportFilterKey?: string, reportFilterValue?: string) {
        this.loading = true;
        this.page = page;
        this.paginatedRequest = new PaginatedRequest(page, this.pageSize, "id");
        this.reportService.getWorksheetStatusReport(new worksheetStatusReportRequest(customerNumber, marketId, marketName, projectId, projectName), this.paginatedRequest, reportFilterKey, reportFilterValue).subscribe(items => {
            this.loading = false;
            this.wsStatusReport = items;
            if (this.wsStatusReport.totalRecords && this.wsStatusReport.totalRecords > 0) {
                this.totalRecords = this.wsStatusReport.totalRecords;
                this.startRecord = ((this.page - 1) * this.pageSize) + 1;
                this.endRecord = this.wsStatusReport.totalRecords < (this.page * this.pageSize) ? this.wsStatusReport.totalRecords : (this.page * this.pageSize);
                this.showWsSearchOption = true;
                this.excelBtnDisabled = false;
                this.showNoWSMessage = false;
                if (!this.wsStatusReport || !this.wsStatusReport.records || this.wsStatusReport.records.length < 1) {
                    this.showNoWSMessage = true;
                    // this.showWsSearchOption = false;
                    this.excelBtnDisabled = true;
                    this.wsStatusReport.records = [];
                    this.noWorksheetMessage = ['There are no worksheets to display'];
                }
            } else {
                this.totalRecords = 0;
                this.wsStatusReport.records = [];
                this.noWorksheetMessage = ['There are no worksheets to display'];
                this.showNoWSMessage = true;
                this.excelBtnDisabled = true;
                // this.showWsSearchOption = false;
            }
            this.sendDataToAnalytics();
        }, error => {
            this.errorMessage.push(error.error.message);
            this.showNoWSMessage = true;
            this.noWorksheetMessage = [''];
            this.showWsSearchOption = false;
            this.excelBtnDisabled = true;
            this.wsStatusReport.records = [];
            this.totalRecords = 0;
            this.loading = false;
        });
    }

    private sendDataToAnalytics() {
        this.analyticsService.trackReportSearch('worksheet_status_report');
    }

    onEnteringSearchValue(value) {
        this.reportFilterSearchValue = value;
        if (this.reportFilterSearchValue != '') {
            this.loadPage(1, this.selectedAccountNumber, this.selectedMarket[0].id, this.selectedMarket[0].name, this.selectedProjectId, this.selectedProjectName, this.reportFilterKeyValue, this.reportFilterSearchValue);
        } else {
            this.loadPage(1, this.selectedAccountNumber, this.selectedMarket[0].id, this.selectedMarket[0].name, this.selectedProjectId, this.selectedProjectName);
        }
    }

    filteWsStatusReport() {
        this.showNoWSMessage = false;
        if (this.reportFilterSearchValue != '') {
            this.loadPage(1, this.selectedAccountNumber, this.selectedMarket[0].id, this.selectedMarket[0].name, this.selectedProjectId, this.selectedProjectName, this.reportFilterKeyValue, this.reportFilterSearchValue);
        } else {
            this.loadPage(1, this.selectedAccountNumber, this.selectedMarket[0].id, this.selectedMarket[0].name, this.selectedProjectId, this.selectedProjectName);
        }

    }

    sortColumns(n: number) {
        if (n == 1) {
            this.sortWorksheetName();
        } else if (n == 2) {
            this.sortOracleProjectNumber();
        } else if (n == 3) {
            this.sortProjectName();
        } else if (n == 4) {
            this.sortInitiatedBy();
        } else if (n == 5) {
            this.sortInitiatedDate();
        } else if (n == 6) {
            this.sortSubmittedApprovalDate();
        } else if (n == 7) {
            this.sortSubmittedApprovalBy();
        } else if (n == 8) {
            this.sortDesignatedApprover();
        } else if (n == 9) {
            this.sortApprovedDate();
        } else if (n == 10) {
            this.sortApprovedBy();
        } else if (n == 11) {
            this.sortStatus();
        }
    }



    sortTable(n: number) {
        this.sortColumns(n);
        var tempSortDir = this.sortDirection;
        if (this.sortDirection === '') {
            this.wsStatusReport.records = JSON.parse(JSON.stringify(this.tempOrders));
        }
        if (this.wsStatusReport.records && this.wsStatusReport.records.length) {
            var orderArray = this.wsStatusReport.records
            orderArray.sort(function (a, b) {
                let keyA, keyB;
                if (n == 1) {
                    keyA = a.worksheetName.toUpperCase();
                    keyB = b.worksheetName.toUpperCase();
                } else if (n == 2) {
                    keyA = a.oracleProjectNumber;
                    keyB = b.oracleProjectNumber;
                } else if (n == 3) {
                    keyA = a.projectName.toUpperCase();
                    keyB = b.projectName.toUpperCase();
                } else if (n == 4) {
                    keyA = a.initiatorName;
                    keyB = b.initiatorName;
                } else if (n == 5) {
                    keyA = new Date(a.wsCreateDate);
                    keyB = new Date(b.wsCreateDate);
                } else if (n == 6) {
                    keyA = new Date(a.approvalCreateDate);
                    keyB = new Date(b.approvalCreateDate);
                } else if (n == 7) {
                    keyA = a.initiatorName;
                    keyB = b.initiatorName;
                } else if (n == 8) {
                    keyA = a.approverName;
                    keyB = b.approverName;
                } else if (n == 9) {
                    keyA = new Date(a.approvalClosedDate);
                    keyB = new Date(b.approvalClosedDate);
                } else if (n == 10) {
                    keyA = a.approverName;
                    keyB = b.approverName;
                } else if (n == 11) {
                    keyA = a.status;
                    keyB = b.status;
                }

                if (tempSortDir == 'asc') {
                    if (keyA < keyB) return -1;
                    if (keyA > keyB) return 1;
                    return 0;
                } else if (tempSortDir == 'desc') {
                    if (keyA < keyB) return 1;
                    if (keyA > keyB) return -1;
                    return 0;
                }
            });
            this.wsStatusReport.records = orderArray;
        }
    }

    sortProjectName() {
        if (this.projectNameSortDirection === '') {
            this.projectNameSortDirection = 'asc';
        } else if (this.projectNameSortDirection === 'asc') {
            this.projectNameSortDirection = 'desc';
        } else {
            this.projectNameSortDirection = '';
        }
        this.sortDirection = this.projectNameSortDirection;
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.initDateSortDirection = '';
        this.SubApprDateDeliveryDate = '';
        this.subApprBySortDirection = '';
        this.DesApproverSortDirection = '';
        this.apprDateSortDirection = '';
        this.approvedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortWorksheetName() {
        if (this.wsNameSortDirection === '') {
            this.wsNameSortDirection = 'asc';
        } else if (this.wsNameSortDirection === 'asc') {
            this.wsNameSortDirection = 'desc';
        } else {
            this.wsNameSortDirection = '';
        }
        this.sortDirection = this.wsNameSortDirection;
        this.projectNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.initDateSortDirection = '';
        this.SubApprDateDeliveryDate = '';
        this.subApprBySortDirection = '';
        this.DesApproverSortDirection = '';
        this.apprDateSortDirection = '';
        this.approvedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortOracleProjectNumber() {
        if (this.oraclePrNumberSortDirection === '') {
            this.oraclePrNumberSortDirection = 'asc';
        } else if (this.oraclePrNumberSortDirection === 'asc') {
            this.oraclePrNumberSortDirection = 'desc';
        } else {
            this.oraclePrNumberSortDirection = '';
        }
        this.sortDirection = this.oraclePrNumberSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.initBySortDirection = '';
        this.initDateSortDirection = '';
        this.SubApprDateDeliveryDate = '';
        this.subApprBySortDirection = '';
        this.DesApproverSortDirection = '';
        this.apprDateSortDirection = '';
        this.approvedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortInitiatedBy() {
        if (this.initBySortDirection === '') {
            this.initBySortDirection = 'asc';
        } else if (this.initBySortDirection === 'asc') {
            this.initBySortDirection = 'desc';
        } else {
            this.initBySortDirection = '';
        }
        this.sortDirection = this.initBySortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initDateSortDirection = '';
        this.SubApprDateDeliveryDate = '';
        this.subApprBySortDirection = '';
        this.DesApproverSortDirection = '';
        this.apprDateSortDirection = '';
        this.approvedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortInitiatedDate() {
        if (this.initDateSortDirection === '') {
            this.initDateSortDirection = 'asc';
        } else if (this.initDateSortDirection === 'asc') {
            this.initDateSortDirection = 'desc';
        } else {
            this.initDateSortDirection = '';
        }
        this.sortDirection = this.initDateSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.SubApprDateDeliveryDate = '';
        this.subApprBySortDirection = '';
        this.DesApproverSortDirection = '';
        this.apprDateSortDirection = '';
        this.approvedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortSubmittedApprovalDate() {
        if (this.SubApprDateDeliveryDate === '') {
            this.SubApprDateDeliveryDate = 'asc';
        } else if (this.SubApprDateDeliveryDate === 'asc') {
            this.SubApprDateDeliveryDate = 'desc';
        } else {
            this.SubApprDateDeliveryDate = '';
        }
        this.sortDirection = this.SubApprDateDeliveryDate;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.initDateSortDirection = '';
        this.subApprBySortDirection = '';
        this.DesApproverSortDirection = '';
        this.apprDateSortDirection = '';
        this.approvedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortSubmittedApprovalBy() {
        if (this.subApprBySortDirection === '') {
            this.subApprBySortDirection = 'asc';
        } else if (this.subApprBySortDirection === 'asc') {
            this.subApprBySortDirection = 'desc';
        } else {
            this.subApprBySortDirection = '';
        }
        this.sortDirection = this.subApprBySortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.initDateSortDirection = '';
        this.SubApprDateDeliveryDate = '';
        this.DesApproverSortDirection = '';
        this.apprDateSortDirection = '';
        this.approvedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortDesignatedApprover() {
        if (this.DesApproverSortDirection === '') {
            this.DesApproverSortDirection = 'asc';
        } else if (this.DesApproverSortDirection === 'asc') {
            this.DesApproverSortDirection = 'desc';
        } else {
            this.DesApproverSortDirection = '';
        }
        this.sortDirection = this.DesApproverSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.initDateSortDirection = '';
        this.SubApprDateDeliveryDate = '';
        this.subApprBySortDirection = '';
        this.apprDateSortDirection = '';
        this.approvedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortApprovedDate() {
        if (this.apprDateSortDirection === '') {
            this.apprDateSortDirection = 'asc';
        } else if (this.apprDateSortDirection === 'asc') {
            this.apprDateSortDirection = 'desc';
        } else {
            this.apprDateSortDirection = '';
        }
        this.sortDirection = this.apprDateSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.initDateSortDirection = '';
        this.SubApprDateDeliveryDate = '';
        this.subApprBySortDirection = '';
        this.DesApproverSortDirection = '';
        this.approvedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortApprovedBy() {
        if (this.approvedBySortDirection === '') {
            this.approvedBySortDirection = 'asc';
        } else if (this.approvedBySortDirection === 'asc') {
            this.approvedBySortDirection = 'desc';
        } else {
            this.approvedBySortDirection = '';
        }
        this.sortDirection = this.approvedBySortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.initDateSortDirection = '';
        this.SubApprDateDeliveryDate = '';
        this.subApprBySortDirection = '';
        this.DesApproverSortDirection = '';
        this.apprDateSortDirection = '';
        this.statusSortDirection = '';
    }

    sortStatus() {
        if (this.statusSortDirection === '') {
            this.statusSortDirection = 'asc';
        } else if (this.statusSortDirection === 'asc') {
            this.statusSortDirection = 'desc';
        } else {
            this.statusSortDirection = '';
        }
        this.sortDirection = this.statusSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.initDateSortDirection = '';
        this.SubApprDateDeliveryDate = '';
        this.subApprBySortDirection = '';
        this.DesApproverSortDirection = '';
        this.apprDateSortDirection = '';
        this.approvedBySortDirection = '';
    }

    downloadXls() {
        this.excelLoading = true;
        this.excelBtnDisabled = true;
        this.reportService.downloadWorksheetStatusReport(new worksheetStatusReportRequest(this.selectedAccountNumber, this.selectedMarket[0].id, this.selectedMarket[0].name, this.selectedProjectId, this.selectedProjectName)).subscribe((resp) => {
            const fileName = resp.headers.get('filename') ? resp.headers.get('filename') : 'Worksheet_Status_' + this.selectedMarket[0].name + '_' + new Date();
            const data = resp.body;
            this.blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName + '.xlsx';
            link.click();
            this.excelLoading = false;
            this.excelBtnDisabled = false;
        }, error => {
            this.onError("Error downloading the file!!!");
            this.excelLoading = false;
            this.excelBtnDisabled = false;
        });
    }

    private onError(msg: string) {
        this.toastr.error(msg, 'Error!', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right'
        });
    }

    dismissErrorMessage() {
        this.errorMessage = [];
    }

    orgDeSelect() {
        this.selectedOrg = [];
        this.markets = [];
        this.projects = [];
        this.selectedMarket = [];
        this.selectedProject = [];
        this.totalRecords = 0;
        this.wsStatusReport = new WorksheetStatusHistory();
        this.errorMessage = [];
        this.showNoWSMessage = false;
        this.showWsSearchOption = false;
        this.excelBtnDisabled = true;
        this.marketDropdownDisabled = true;
    }

    marketDeSelect() {
        this.selectedMarket = [];
        this.projects = [];
        this.selectedProject = [];
        this.totalRecords = 0;
        this.wsStatusReport = new WorksheetStatusHistory();
        this.errorMessage = [];
        this.showNoWSMessage = false;
        this.showWsSearchOption = false;
        this.excelBtnDisabled = true;
    }

    projectDeselect() {
        this.selectedProject = [];
        this.totalRecords = 0;
        this.wsStatusReport = new WorksheetStatusHistory();
        this.errorMessage = [];
        this.showNoWSMessage = false;
        this.showWsSearchOption = false;
        this.excelBtnDisabled = true;
    }

    setOrgDropdownSettings() {
        this.orgDropdownSettings = {
            singleSelection: true,
            textField: 'Name',
            itemsShowLimit: 1,
            idField: 'Organization ID',
            allowSearchFilter: true,
            clearSearchFilter: true,
            closeDropDownOnSelection: true
        }
    }

    setMarketDropdownSettings() {
        this.marketDropdownSettings = {
            singleSelection: true,
            textField: 'name',
            itemsShowLimit: 1,
            idField: 'id',
            allowSearchFilter: true,
            clearSearchFilter: true,
            closeDropDownOnSelection: true
        }
    }

    setProjectDropdownSettings() {
        this.projectDropdownSettings = {
            singleSelection: true,
            textField: 'name',
            itemsShowLimit: 1,
            idField: 'id',
            allowSearchFilter: true,
            clearSearchFilter: true,
            closeDropDownOnSelection: true
        }
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-reports/worksheetstatus-report/worksheetstatus-report.component.ts